(function () {
  let refreshTimer = null;

  function getActiveCurrency() {
    if (window.Currency && Currency.currentCurrency) {
      return Currency.currentCurrency;
    }

    if (window.Shopify && Shopify.currency) {
      return Shopify.currency.active || Shopify.currency.shop || "EUR";
    }

    return "EUR";
  }

  function toCents(value) {
    if (value === null || value === undefined || value === "") return 0;

    const clean = String(value).replace(/[^\d-]/g, "");
    const parsed = parseInt(clean, 10);

    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function formatMoney(cents, currency) {
    const value = toCents(cents);

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency || "EUR"
      }).format(value / 100);
    } catch (e) {
      return (value / 100).toFixed(2);
    }
  }

  function addPriceLookup(map, variantId, priceCents, regularCents, compareCents) {
    const id = String(variantId || "");
    const price = toCents(priceCents);
    const regular = toCents(regularCents);
    const compare = toCents(compareCents);
    const bestRegular = Math.max(regular, compare);

    if (!id || !price) return;

    const existing = map.get(id);

    if (!existing) {
      map.set(id, {
        priceCents: price,
        regularCents: bestRegular
      });
      return;
    }

    existing.priceCents = existing.priceCents || price;
    existing.regularCents = Math.max(existing.regularCents || 0, bestRegular || 0);
  }

  function buildPriceLookup(cartRoot) {
    const priceLookup = new Map();

    // 1) Server-rendered cart data. Works after page refresh / page navigation.
    cartRoot.querySelectorAll(".ajax-cart__variant-price[data-variant-id]").forEach((el) => {
      addPriceLookup(
        priceLookup,
        el.dataset.variantId,
        el.dataset.priceCents,
        el.dataset.regularCents,
        el.dataset.compareCents
      );
    });

    // 2) Product-card variant data. This fixes immediate add-to-cart from collection cards.
    document.querySelectorAll(".product-prices .price[data-variant-id]").forEach((el) => {
      addPriceLookup(
        priceLookup,
        el.dataset.variantId,
        el.dataset.priceCents,
        el.dataset.regularCents,
        el.dataset.compareCents
      );
    });

    // 3) Product-page variant data. This fixes immediate add-to-cart from product pages.
    document.querySelectorAll("select.product__select option[value]").forEach((el) => {
      addPriceLookup(
        priceLookup,
        el.value,
        el.dataset.priceCents,
        el.dataset.regularCents,
        el.dataset.compareCents
      );
    });

    return priceLookup;
  }

  function refreshMiniCartCompare() {
    const cartRoot = document.querySelector(".ajax-cart");
    if (!cartRoot) return;

    const activeCurrency = getActiveCurrency();
    const priceLookup = buildPriceLookup(cartRoot);

    let currentSubtotalCents = 0;
    let regularSubtotalCents = 0;
    let knownLineCount = 0;

    cartRoot.querySelectorAll(".ajax-cart__item[data-variant-id]").forEach((lineWrap) => {
      const variantId = String(lineWrap.dataset.variantId || "");
      const lookup = priceLookup.get(variantId);
      const compareEl = lineWrap.querySelector(".js-compare-price");

      if (!lookup) {
        if (compareEl) {
          compareEl.innerHTML = "";
          compareEl.style.display = "none";
        }
        return;
      }

      const qtyEl = lineWrap.querySelector(".ajax-cart__quantity-quantity");
      const qty = Math.max(toCents(qtyEl ? qtyEl.textContent : "1"), 1);

      const currentUnitPrice = toCents(lookup.priceCents);
      const regularUnitPrice =
        toCents(lookup.regularCents) > currentUnitPrice
          ? toCents(lookup.regularCents)
          : 0;

      const lineCurrent = currentUnitPrice * qty;
      const lineRegular = regularUnitPrice > 0 ? regularUnitPrice * qty : lineCurrent;

      currentSubtotalCents += lineCurrent;
      regularSubtotalCents += lineRegular;
      knownLineCount += 1;

      if (compareEl) {
        if (regularUnitPrice > currentUnitPrice) {
          compareEl.innerHTML = formatMoney(lineRegular, activeCurrency);
          compareEl.style.display = "";
        } else {
          compareEl.innerHTML = "";
          compareEl.style.display = "none";
        }
      }
    });

    const subtotalCompareEl = cartRoot.querySelector(".js-subtotal-compare");

    if (subtotalCompareEl) {
      if (
        knownLineCount > 0 &&
        regularSubtotalCents > currentSubtotalCents &&
        currentSubtotalCents > 0
      ) {
        subtotalCompareEl.innerHTML = formatMoney(regularSubtotalCents, activeCurrency);
        subtotalCompareEl.style.display = "";
      } else {
        subtotalCompareEl.innerHTML = "";
        subtotalCompareEl.style.display = "none";
      }
    }
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshMiniCartCompare, delay || 0);
  }

  function runRefreshPasses() {
    [0, 50, 150, 350, 800].forEach((delay) => {
      setTimeout(refreshMiniCartCompare, delay);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const cartRoot = document.querySelector(".ajax-cart");
    if (!cartRoot) return;

    const observer = new MutationObserver(() => {
      scheduleRefresh(40);
    });

    observer.observe(cartRoot, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });

    cartRoot.addEventListener("click", () => {
      runRefreshPasses();
    });

    document.addEventListener("click", () => {
      runRefreshPasses();
    });

    runRefreshPasses();
  });
})();